import AdminBalanceProfit from 'components/Admin/BalanceProfit/AdminBalanceProfit';
import { FC } from 'react';

const AdminBalanceProfitPage: FC = () => {
	return <AdminBalanceProfit />;
};

export default AdminBalanceProfitPage;
